import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { LocalizationProvider, MobileDatePicker } from '@mui/lab';
import { useEffect, useState } from 'react';
import { Stack } from '@mui/material';

interface DatePickerSubfieldsProps {
  label?: string;
  setValue: (value: string) => void;
  defaultValue: string;
  futureDateEnabled?: boolean;
}

export default function DatePickerSubfields({
  defaultValue,
  label = '',
  setValue,
  futureDateEnabled = false,
}: DatePickerSubfieldsProps) {
  const [datePickValue, setDatePickValue] = useState<Date | null>(null);

  useEffect(() => {
    if (defaultValue && defaultValue !== '') {
      try {
        if (!Number.isNaN(Number(defaultValue))) {
          setDatePickValue(new Date(parseInt(defaultValue, 10)));
        } else {
          const parsedDate = new Date(defaultValue);
          if (!Number.isNaN(parsedDate.getTime())) {
            setDatePickValue(parsedDate);
          }
        }
      } catch (error) {
        console.error('Erro ao converter defaultValue para data:', error);
        setDatePickValue(null);
      }
    } else {
      setDatePickValue(null);
    }
  }, [defaultValue]);

  const handleChange = (newValue: Date | null) => {
    newValue?.setHours(0, 0, 0, 0);
    setDatePickValue(newValue);
    
    if (newValue) {
      const day = newValue.getDate().toString().padStart(2, '0');
      const month = (newValue.getMonth() + 1).toString().padStart(2, '0');
      const year = newValue.getFullYear();
      const formattedDate = `${day}-${month}-${year}`;
      setValue(formattedDate);
    } else {
      setValue('');
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack sx={{ width: '100%', minWidth: '100px' }}>
        <MobileDatePicker
          label={label}
          inputFormat="dd/MM/yyyy"
          value={datePickValue}
          onChange={handleChange}
          renderInput={(params: any) => <TextField {...params} />}
          disableFuture={!futureDateEnabled}
        />
      </Stack>
    </LocalizationProvider>
  );
}
